export class ApiRequest<T> {
    constructor() {
        this.sorts = new Array<CustomSort<T>>();
        this.paging = true;
    }
    paging?: boolean;
    pageIndex?: number;
    pageSize?: number;
    sorts?: Array<CustomSort<T>>;
    filters?: CustomGroupPredicate<T>;
}
export class CustomGroupPredicate<T> {
    constructor() {
        this.groupOperator = "and";
        this.predicates = []
    }
    groupOperator?: "and" | "or";
    predicates?: Array<CustomFieldPredicate<T> | CustomGroupPredicate<T>>
}
export class CustomFieldPredicate<T> {
    constructor() {
        this.operator = "=";
        this.not = false;
    }
    fieldName: keyof T & string;
    operator: "=" | ">" | ">=" | "<" | "<=" | "like" | "startsWith" | "endsWith" | "empty" | "in" | "between";
    value1: any;
    value2?: any;
    not?: boolean;
}
export class CustomSort<T> {
    constructor() {
        this.ascending = true;
    }
    fieldName: keyof T & string;
    ascending?: boolean;
}